import { ChevronDown } from "@faire/slate-icons/ChevronDown";
import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  /**
   * The error of the select component.
   */
  error?: React.ReactNode;

  /**
   * The placeholder of the select component.
   */
  placeholder?: React.ReactNode;

  /**
   * The ref of the select component.
   */
  ref?: React.Ref<HTMLSelectElement>;
};

export const SelectBase: React.FC<IProps> = ({
  error,
  placeholder = "",
  children,
  className,
  ...props
}) => {
  const selectCls = selectStyle.cls({ error: !!error, className });

  return (
    <div className="relative w-full">
      <select className={selectCls} aria-invalid={!!error} {...props}>
        <option data-placeholder disabled value="" hidden>
          {placeholder}
        </option>
        {children}
      </select>
      <div className="fs-select__icon-wrapper" aria-hidden>
        <ChevronDown className="fs-select__icon" color="inherit" />
      </div>
    </div>
  );
};

const selectStyle = tsv({
  base: "fs-form-field fs-select interactive peer",
  variants: {
    error: {
      true: "fs-form-field__border--error",
    },
  },
});
